<template>
  <div class="content">
    <div class="top">
      <div class="title">探店吃喝玩乐App接入第三方SDK目录</div>
      <div class="dsc">
        <p>为保障探店吃喝玩乐App相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）实现相关目的。</p>
        <p>我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。</p>
        <p>我们对接入的相关第三方SDK在目录中列明。</p>
        <p>请注意，第三方SDK可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。</p>
      </div>
    </div>
    <div class="header" v-for="(item,index) in info" :key="index">
      <h6>{{item.title}}</h6>
      <div class="info" v-for="(i,j) in item.content" :key="j">
        {{i.title}}<span v-html="i.content"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      info: [
        {
          title: "百度定位SDK",
          content: [
            {
              title: '使用目的：',
              content: '用于实现定位'
            },
            {
              title: '数据类型：',
              content: '设备标识信息、地理位置信息'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="http://map.baidu.com/zt/client/privacy/">http://map.baidu.com/zt/client/privacy/</a>'
            }
          ]
        },
        {
          title: "百度地图搜索SDK",
          content: [
            {
              title: '使用目的：',
              content: '用于实现周边兴趣点搜索等功能'
            },
            {
              title: '数据类型：',
              content: '设备标识信息、地理位置信息'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="http://map.baidu.com/zt/client/privacy/">http://map.baidu.com/zt/client/privacy/</a>'
            }
          ]
        },
        {
          title: "Umeng（友盟） SDK",
          content: [
            {
              title: '使用目的：',
              content: '统计分析、推送信息'
            },
            {
              title: '数据类型：',
              content: '设备标识信息、应用列表'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="https://developer.umeng.com/docs/119267/detail/118585；https://www.umeng.com/push">https://developer.umeng.com/docs/119267/detail/118585；https://www.umeng.com/push</a>'
            }
          ]
        },
        {
          title: "腾讯云即时通信 IM SDK",
          content: [
            {
              title: '使用目的：',
              content: '用于实现实时聊天功能'
            },
            {
              title: '数据类型：',
              content: '设备标识信息'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="https://cloud.tencent.com/document/product/269/34004">https://cloud.tencent.com/document/product/269/34004</a>'
            }
          ]
        },
        {
          title: "微信开放平台 SDK",
          content: [
            {
              title: '使用目的：',
              content: '接入微信开放平台SDK，支持微信授权登录、微信分享和微信支付'
            },
            {
              title: '数据类型：',
              content: '设备标识信息'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="https://open.weixin.qq.com/">https://open.weixin.qq.com/</a>'
            }
          ]
        },
        {
          title: "MobTech ShareSdk",
          content: [
            {
              title: '使用目的：',
              content: '快速实现微信分享收藏功能'
            },
            {
              title: '数据类型：',
              content: '设备标识信息'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="https://www.mob.com/about/policy">https://www.mob.com/about/policy</a>'
            }
          ]
        },
        {
          title: "阿里云短视频 SDK",
          content: [
            {
              title: '使用目的：',
              content: '用于实现音视频拍摄、特效编辑、本地转码、高速上传、自动化转码处理、媒体资源管理、分发加速、播放等功能'
            },
            {
              title: '数据类型：',
              content: '设备标识信息'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="https://promotion.aliyun.com/ntms/act/shortvideo.html">https://promotion.aliyun.com/ntms/act/shortvideo.html</a>'
            }
          ]
        },
        {
          title: "阿里视频上传功能 SDK",
          content: [
            {
              title: '使用目的：',
              content: '配合短视频sdk实现视频的上传功能'
            },
            {
              title: '数据类型：',
              content: '设备标识信息'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="https://www.alibabacloud.com/help/zh/doc-detail/62945.htm">https://www.alibabacloud.com/help/zh/doc-detail/62945.htm</a>'
            }
          ]
        },
        {
          title: "阿里 OSS SDK",
          content: [
            {
              title: '使用目的：',
              content: '配合短视频sdk实现视频的网络存储功能'
            },
            {
              title: '数据类型：',
              content: '设备标识信息'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="https://developer.aliyun.com/article/608368">https://developer.aliyun.com/article/608368</a>'
            }
          ]
        },
        {
          title: "小米PUSH",
          content: [
            {
              title: '使用目的：',
              content: '推送消息'
            },
            {
              title: '数据类型：',
              content: '设备标识信息'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="https://dev.mi.com/console/appservice/push.html">https://dev.mi.com/console/appservice/push.html</a>'
            }
          ]
        },
        {
          title: "VIVO PUSH",
          content: [
            {
              title: '使用目的：',
              content: '推送消息'
            },
            {
              title: '数据类型：',
              content: '设备标识信息'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="https://dev.vivo.com.cn/documentCenter/doc/365">https://dev.vivo.com.cn/documentCenter/doc/365</a>'
            }
          ]
        },
        {
          title: "OPPO PUSH",
          content: [
            {
              title: '使用目的：',
              content: '推送消息'
            },
            {
              title: '数据类型：',
              content: '设备标识信息'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="https://open.oppomobile.com/wiki/doc#id=10196">https://open.oppomobile.com/wiki/doc#id=10196</a>'
            }
          ]
        },
        {
          title: "魅族PUSH",
          content: [
            {
              title: '使用目的：',
              content: '推送消息'
            },
            {
              title: '数据类型：',
              content: '设备标识信息'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="https://open.flyme.cn/open-web/views/push.html">https://open.flyme.cn/open-web/views/push.html</a>'
            }
          ]
        },
        {
          title: "华为PUSH",
          content: [
            {
              title: '使用目的：',
              content: '推送消息'
            },
            {
              title: '数据类型：',
              content: '设备标识信息'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="https://developer.huawei.com/consumer/cn/hms/huawei-pushkit">https://developer.huawei.com/consumer/cn/hms/huawei-pushkit</a>'
            }
          ]
        },
        {
          title: "UC 啄木鸟",
          content: [
            {
              title: '使用目的：',
              content: '方便的跟踪线上异常，高效定位问题，快速解决问题。'
            },
            {
              title: '数据类型：',
              content: '设备标识信息'
            },
            {
              title: '官网链接：',
              content: '<a style="color:#4F83E2;" href="http://open-uc.uc.cn/solution/zhuomuniao">http://open-uc.uc.cn/solution/zhuomuniao</a>'
            }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.content {
  margin-bottom: 100px;
  .top{
    padding: 0px 29px;
    .title{
      font-size: 30px;
      text-align: center;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      margin: 35px 0 10px 0;
    }
    .dsc{
      font-size: 26px;
      font-weight: 400;
      line-height:40px;
      color: rgba(85, 85, 85, 1);
    }
  }
  .header {
    padding: 0px 29px;
    h6 {
      font-size: 30px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      margin: 35px 0 10px 0;
    }
    .info {
      // text-align: justify;
      font-size: 28px;
      font-weight: bold;
      line-height:40px;
      color: #000;
      span{
        font-size: 26px;
        font-weight: normal;
        color:#333;
      }
    }
  }
}
</style>